module.exports = __webpack_public_path__ + "static/img/app05.96ae06c.png";


//////////////////
// WEBPACK FOOTER
// ./static/appPic/app05.png
// module id = F+Dm
// module chunks = 1